export const websocketActionsWorkspaces = {
  transactions: 'transactions',
}
